interface Properties {
  width?: number;
  height?: number;
}

const BlocksIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_74013_752)'>
        <path
          d='M17.5161 1.5C19.197 1.50005 20.8051 2.15914 21.9878 3.32617C23.1698 4.49271 23.8305 6.07085 23.8306 7.71191V17.1094H7.99951V1.5H17.5161Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
        <path
          d='M23.8301 18.2083V33.7922H7.99902V18.2083H23.8301Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
        <path
          d='M32.7397 18.2083C33.7949 18.2083 34.8391 18.4137 35.813 18.8118C36.7866 19.2098 37.6703 19.7922 38.4136 20.5256C39.1568 21.2592 39.7458 22.1294 40.147 23.0852C40.5481 24.0409 40.7543 25.0647 40.7544 26.0979V33.7922H24.9233V18.2083H32.7397Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
        <path
          d='M23.8301 34.9156V50.4996H16.0918C15.0266 50.5001 13.9724 50.2936 12.9893 49.8922C12.0059 49.4906 11.1129 48.9022 10.3623 48.1617C9.61186 47.4214 9.01744 46.5436 8.6123 45.5787C8.20719 44.6138 7.99905 43.58 7.99902 42.5367V34.9156H23.8301Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
        <path
          d='M40.7544 34.9156V42.7789C40.7544 44.8202 39.9331 46.7825 38.4644 48.2321C36.995 49.6822 34.9971 50.4996 32.9106 50.4996H24.9233V34.9156H40.7544Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
        <path
          d='M32.7217 18.21C34.022 18.2089 35.3022 18.5195 36.4521 19.1143C37.4195 19.6147 38.268 20.3052 38.9512 21.1367L24.917 32.126V18.21H32.7217Z'
          fill='#745BE3'
          stroke='white'
          stroke-width='3'
        />
      </g>
      <defs>
        <clipPath id='clip0_74013_752'>
          <rect width='52' height='52' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BlocksIconActive;
